import { getVariationFillColor } from '@gonfalon/flag-variations/getVariationFillColor';
import type { List, Map } from '@gonfalon/immutable-shim/immutableShim';
import { Variation } from '@gonfalon/ui/variation';
import clsx from 'clsx';
import nullthrows from 'nullthrows';

import { VARIATION_NOT_FOUND } from '#components/InstructionList/instructionListUtils';
import type { Variation as variationType } from '#utils/flags/records/Variation';

import styles from './styles.module.css';

const getVariationIndex = (variationID: string, variations: List<variationType>) =>
  variations.findIndex((v) => v._id === variationID);

export const RolloutDescription = ({
  contextKind,
  rolloutWeights,
  variations,
  bucketBy,
}: {
  contextKind?: string;
  rolloutWeights: Map<string, number>;
  variations: List<variationType>;
  bucketBy?: string;
}) => {
  const renderVariation = (index: number) => (
    <Variation
      className={clsx(styles.variationInstructionEntry, 'u-ml-s')}
      key={index}
      color={getVariationFillColor(index)}
      value={nullthrows(variations.get(index), `expected a variation at index ${index}`).getDisplay()}
    />
  );

  const sortedRolloutWeights = rolloutWeights.sortBy((_value, variationID) => {
    const variationIndex = getVariationIndex(variationID, variations);
    if (variationIndex === -1) {
      return Infinity;
    }
    return variationIndex;
  });

  const sortedEntries = sortedRolloutWeights.entrySeq().toArray();

  return (
    <span className={styles.RolloutDescription}>
      {sortedEntries.map(([variationID, value], index) => {
        const variationIndex = getVariationIndex(variationID, variations);
        const displayedVariationIndex: number | string = variationIndex !== -1 ? variationIndex : VARIATION_NOT_FOUND;
        const percent = value / 1000;
        const additionalRolloutText = index !== sortedEntries.length - 1 && ', ';
        return (
          <span key={variationID} className={styles.rolloutDescriptionItem}>
            {typeof displayedVariationIndex === 'number'
              ? renderVariation(displayedVariationIndex)
              : ` ${VARIATION_NOT_FOUND}`}
            <span className="u-ml-s">({percent}%)</span>
            {additionalRolloutText}
          </span>
        );
      })}
      {bucketBy && ` bucketed by ${contextKind || 'context'} attribute ${bucketBy}`}
    </span>
  );
};
